import { render } from "./EditExitDeclarationPage.vue?vue&type=template&id=22b11d18"
import script from "./EditExitDeclarationPage.vue?vue&type=script&lang=js"
export * from "./EditExitDeclarationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__